class serigrafiaSelector extends HTMLElement {
  constructor() {
    super();

    //main variables
    this.selectors = {
      propertyName: "Serigrafia",
      productFormSelector: ".product-form__buy-buttons form",
    };

    this.playerBlock = this.querySelector("#number-player");
    this.customBlock = this.querySelector("#custom-name");

    this.customNumber = this.customBlock.querySelector('input[name="dorsal"]');
    this.customName = this.customBlock.querySelector('input[name="player"]');

    this.selectPlayer = this.querySelector("select#player");

    this.selectPlayer.addEventListener("change", this.changePlayer.bind(this));

    this.customNumber.addEventListener("keyup", this.onNumbersType.bind(this));
    this.customNumber.addEventListener(
      "change",
      this.onChangeNumber.bind(this),
    );

    this.customName.addEventListener("keyup", this.onNameType.bind(this));
    this.customName.addEventListener("change", this.onChangeName.bind(this));
  }

  connectedCallback() {
    setTimeout(() => {
      let selectedInput = this.querySelector("input:checked");
      let available = true;
      if (
        selectedInput.closest(".block-swatch").classList.contains("is-disabled")
      ) {
        available = false;
      }
      this.toggleBlocks(selectedInput.dataset.valueOrder, available);
      this.clearCustom();

      // If a .second-image-mobile exists within the same option selector,
      // make it trigger the preview image (same as selecting media 2)
      try {
        const optionSelector = this.closest(".product-form__option-selector");
        if (optionSelector) {
          this._secondImageEl = optionSelector.querySelector(
            ".second-image-mobile",
          );
          if (this._secondImageEl) {
            this._secondImageClickHandler = this.goToPreviewImage.bind(this);
            this._secondImageEl.addEventListener(
              "click",
              this._secondImageClickHandler,
            );
            // Support keyboard activation (Enter / Space)
            this._secondImageKeyHandler = (e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                this.goToPreviewImage();
              }
            };
            this._secondImageEl.addEventListener(
              "keydown",
              this._secondImageKeyHandler,
            );
          }
        }
      } catch (e) {
        // ignore
      }
    }, 250);
  }
  displaySerigrafia(event) {
    this.toggleBlocks(
      this.querySelector("input:checked").dataset.valueOrder,
      event.detail.variant.available,
    );
    this.closest(".product-form__option-selector").querySelector(
      ".product-form__option-value",
    ).innerText = event.detail.variant.option2;
  }

  changePlayer(event) {
    this.changeProperty(event.target.value);
  }

  onNumbersType(event) {
    event.target.value = event.target.value.replace(/[^0-9]/g, "");
    this.countCharacters(event);
    this._updatePreview();
  }
  onNameType(event) {
    this.countCharacters(event);
    this._updatePreview();
  }

  onChangeNumber(event) {
    this.changeProperty(event.target.value + " - " + this.customName.value);
    this.enableMainButton();
    this._updatePreview();
  }

  onChangeName(event) {
    this.changeProperty(this.customNumber.value + " - " + event.target.value);
    this.enableMainButton();
    this._updatePreview();
  }

  changeProperty(propertyValue) {
    let [number, name] = propertyValue ? propertyValue.split(" - ") : ["", ""];

    number = number.trim() === "" ? "**" : number;
    name = name.trim() === "" ? "**" : name;
    let productForm = document.querySelector(
      this.selectors.productFormSelector,
    );
    productForm.querySelector(
      'input[name="properties[' + this.selectors.propertyName + ']"]',
    ).value = number + " | " + name;

    // Update ALL relevant preview-selectors (option inline, second image media, and global) so both places show the same text
    try {
      const previews = new Set();
      try {
        const optionSelector = this.closest(".product-form__option-selector");
        if (optionSelector)
          optionSelector
            .querySelectorAll("preview-selector")
            .forEach((p) => previews.add(p));
      } catch (e) {}

      try {
        const mediaPreview = document.querySelector(
          '.product__media-item[data-original-position="1"] preview-selector',
        );
        if (mediaPreview) previews.add(mediaPreview);
      } catch (e) {}

      // Also include any global preview-selectors
      try {
        document
          .querySelectorAll("preview-selector")
          .forEach((p) => previews.add(p));
      } catch (e) {}

      if (previews.size) {
        const numVal =
          number.trim() === "" || number.trim() === "**" ? "" : number.trim();
        const nameVal =
          name.trim() === "" || name.trim() === "**" ? "" : name.trim();
        previews.forEach((p) => {
          try {
            p.number = numVal;
            p.name = nameVal;
          } catch (e) {}
        });
      }
    } catch (e) {}
  }

  clearCustom() {
    this.customNumber.value = "";
    this.customName.value = "";
    this._updatePreview();
  }

  _setSecondImageEl() {
    if (this._secondImageEl) return;
    try {
      const optionSelector = this.closest(".product-form__option-selector");
      if (optionSelector)
        this._secondImageEl = optionSelector.querySelector(
          ".second-image-mobile",
        );
    } catch (e) {
      this._secondImageEl = null;
    }
  }

  _setSecondImageVisibility(show) {
    this._setSecondImageEl();
    if (!this._secondImageEl) return;
    try {
      if (show) {
        this._secondImageEl.classList.add("is-visible");
        this._secondImageEl.removeAttribute("hidden");
        this._secondImageEl.setAttribute("aria-hidden", "false");
      } else {
        try {
          const preview = this._secondImageEl.querySelector("preview-selector");
          if (preview && preview === this._createdPreview) {
            preview.remove();
            this._createdPreview = null;
          } else if (preview) {
            try {
              preview.number = "";
              preview.name = "";
            } catch (e) {}
          }
        } catch (e) {}

        this._secondImageEl.classList.remove("is-visible");
        this._secondImageEl.setAttribute("hidden", "");
        this._secondImageEl.setAttribute("aria-hidden", "true");
      }
    } catch (e) {}
  }

  _updatePreview() {
    try {
      const previews = new Set();
      try {
        const optionSelector = this.closest(".product-form__option-selector");
        if (optionSelector)
          optionSelector
            .querySelectorAll("preview-selector")
            .forEach((p) => previews.add(p));
      } catch (e) {}

      try {
        const mediaPreview = document.querySelector(
          '.product__media-item[data-original-position="1"] preview-selector',
        );
        if (mediaPreview) previews.add(mediaPreview);
      } catch (e) {}

      try {
        document
          .querySelectorAll("preview-selector")
          .forEach((p) => previews.add(p));
      } catch (e) {}

      if (!previews.size) return;
      // set properties directly from inputs
      const numVal = this.customNumber ? this.customNumber.value : "";
      const nameVal = this.customName ? this.customName.value : "";
      previews.forEach((p) => {
        try {
          p.number = numVal;
          p.name = nameVal;
        } catch (e) {}
      });
    } catch (e) {
      // no-op
    }
  }

  toggleBlocks(variantName, available) {
    this.removePropertyField();
    if (variantName === "order2") {
      this._setSecondImageVisibility(true);
      this.goToPreviewImage();
      this.customBlock.setAttribute("hidden", false);
      this.playerBlock.removeAttribute("hidden");
      if (!available) {
        this.selectPlayer.setAttribute("disabled", true);
      } else {
        this.selectPlayer.removeAttribute("disabled");
      }
      this.clearCustom();
      this.createPropertyField();
      this.changeProperty(this.selectPlayer.value);
    } else if (variantName === "order3") {
      this._setSecondImageVisibility(true);
      this.goToPreviewImage();
      this.playerBlock.setAttribute("hidden", false);
      this.customBlock.removeAttribute("hidden");
      if (!available) {
        this.customNumber.setAttribute("disabled", true);
        this.customName.setAttribute("disabled", true);
      } else {
        this.customNumber.removeAttribute("disabled");
        this.customName.removeAttribute("disabled");
      }
      this.createPropertyField();
      this.disableMainButton();
    } else {
      this._setSecondImageVisibility(false);
      this.customBlock.setAttribute("hidden", true);
      this.playerBlock.setAttribute("hidden", true);
      this.clearCustom();
    }
  }

  goToPreviewImage() {
    setTimeout(() => {
      // Prefer to attach a preview-selector inside the .second-image-mobile container
      try {
        const optionSelector = this.closest(".product-form__option-selector");
        const secondImageContainer = this._secondImageEl
          ? this._secondImageEl
          : optionSelector
            ? optionSelector.querySelector(".second-image-mobile")
            : null;

        if (secondImageContainer) {
          // ensure container is positioned for absolute child
          try {
            secondImageContainer.style.position =
              secondImageContainer.style.position || "relative";
          } catch (e) {}

          let preview = secondImageContainer.querySelector("preview-selector");
          if (!preview) {
            preview = document.createElement("preview-selector");
            preview.setAttribute("inline", "");
            // try to copy text-color from media preview if available
            const mediaPreview = document.querySelector("preview-selector");
            if (mediaPreview && mediaPreview.getAttribute("text-color")) {
              preview.setAttribute(
                "text-color",
                mediaPreview.getAttribute("text-color"),
              );
            }
            secondImageContainer.appendChild(preview);
            this._createdPreview = preview;
          }
        } else {
          // fallback: create global preview-selector on body
          let preview = null;
          try {
            preview = this.closest("preview-selector");
          } catch (e) {
            preview = null;
          }
          if (!preview) preview = document.querySelector("preview-selector");
          if (!preview) {
            preview = document.createElement("preview-selector");
            const mediaPreview = document.querySelector("preview-selector");
            if (mediaPreview && mediaPreview.getAttribute("text-color")) {
              preview.setAttribute(
                "text-color",
                mediaPreview.getAttribute("text-color"),
              );
            }
            document.body.appendChild(preview);
            this._createdPreview = preview;
          }
        }
      } catch (e) {
        // ignore
      }

      // Buscar imagen 2
      const mediaItem = document.querySelector(
        '.product__media-item[data-original-position="1"]',
      );
      if (!mediaItem) return;

      const mediaId = mediaItem.dataset.mediaId;
      if (!mediaId) return;

      // Buscar la miniatura de imagen 2
      const thumb = document.querySelector(
        `.product__thumbnail-item[data-media-id="${mediaId}"]`,
      );
      if (!thumb) return;

      thumb.click();
    }, 100);
  }

  createPropertyField() {
    let propertyField = document.createElement("input");
    propertyField.setAttribute("type", "hidden");
    propertyField.setAttribute(
      "name",
      "properties[" + this.selectors.propertyName + "]",
    );
    document
      .querySelector(this.selectors.productFormSelector)
      .appendChild(propertyField);
  }

  removePropertyField() {
    let productForm = document.querySelector(
      this.selectors.productFormSelector,
    );
    let propertyField = productForm.querySelector(
      'input[name="properties[' + this.selectors.propertyName + ']"]',
    );
    if (propertyField) {
      propertyField.remove();
    }
  }

  disconnectedCallback() {
    if (this._resizeObserver) {
      this._resizeObserver.disconnect();
      this._resizeObserver = null;
    }
    // Remove click listener from .second-image-mobile if it was attached
    try {
      if (this._secondImageEl && this._secondImageClickHandler) {
        this._secondImageEl.removeEventListener(
          "click",
          this._secondImageClickHandler,
        );
        if (this._secondImageKeyHandler)
          this._secondImageEl.removeEventListener(
            "keydown",
            this._secondImageKeyHandler,
          );
        this._secondImageEl = null;
        this._secondImageClickHandler = null;
        this._secondImageKeyHandler = null;
      }
    } catch (e) {
      // ignore
    }

    // If we dynamically created a preview-selector for this instance, remove it
    try {
      if (this._createdPreview && this._createdPreview.parentNode) {
        this._createdPreview.parentNode.removeChild(this._createdPreview);
        this._createdPreview = null;
      }
    } catch (e) {
      // ignore
    }
  }

  disableMainButton() {
    document
      .querySelector(this.selectors.productFormSelector)
      .querySelector("button#AddToCart")
      .setAttribute("disabled", true);
  }
  enableMainButton() {
    document
      .querySelector(this.selectors.productFormSelector)
      .querySelector("button#AddToCart")
      .removeAttribute("disabled");
  }

  countCharacters(event) {
    let maxNumOfChars = event.target.getAttribute("maxlength");
    let counterElement = event.target
      .closest(".input")
      .querySelector(".character-counter span");
    counterElement.innerText = event.target.value.length + "/" + maxNumOfChars;
  }
}

customElements.define("serigrafia-selector", serigrafiaSelector);

document.addEventListener("variant:changed", function (event) {
  document.querySelector("serigrafia-selector").displaySerigrafia(event);
});
